import { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import httpService from "../config/httpCall";
import { Dropdown } from "semantic-ui-react";
import { internuserFormSubmit } from "../config/apiCall";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
};

const validationSchema = Yup.object().shape({
  internerName: Yup.string()
    .matches(/^([^0-9$%]*)$/, "Only alphabets allowed in Name")
    .required("Name is required"),
  internerCollege: Yup.string().required("College name is required"),
  internerCity: Yup.string()
    .matches(/^([^0-9$%]*)$/, "Only alphabets allowed in City")
    .required("City is required"),
  internermobileValue: Yup.string().required("Enter your mobile number"),
});

const OpenRoleCards = ({ data }) => {
  console.log(data, "data===");
  const courseDetails = [
    {
      key: "fullstack",
      title: "Full-Stack Web Development",
      programs: [
        {
          name: "MERN Elite",
          tech: "HTML, CSS, Bootstrap, React.js, Node.js, MongoDB, DevOps",
          desc: "Build dynamic web apps with CI/CD pipelines.",
        },
        {
          name: "PyStack Pro",
          tech: "HTML, CSS, Bootstrap, React.js, Python, MongoDB, DevOps",
          desc: "Blend Python’s power with modern web tech.",
        },
        {
          name: "Angular Fusion",
          tech: "HTML, CSS, Bootstrap, Angular, Python, MongoDB, DevOps",
          desc: "Create enterprise-grade apps with Angular.",
        },
      ],
      careers: [
        "Full-Stack Developer",
        "DevOps Engineer",
        "Software Engineer (₹6–25 LPA)",
      ],
    },
    {
      key: "mernstack",
      title: "MERN Stack",
      tech: "React.js, Node.js, Express.js, MongoDB",
      desc: "Develop scalable web apps with MERN stack.",
      careers: ["MERN Developer", "Front-End/Back-End Engineer (₹5–15 LPA)"],
    },
    {
      key: "meanstack",
      title: "MEAN Stack",
      tech: "Angular, Node.js, Express.js, MongoDB",
      desc: "Build cutting-edge apps with MEAN stack.",
      careers: ["MEAN Developer", "Full-Stack Engineer (₹5–15 LPA)"],
    },
    {
      key: "aiml",
      title: "AI & Machine Learning",
      tech: "Python, R, TensorFlow, PyTorch, Neural Networks, Data Pre-processing",
      desc: "Create AI models for chatbots, image recognition, & more.",
      careers: [
        "AI Research Scientist",
        "ML Engineer",
        "AI Prompt Engineer (₹10–25 LPA)",
      ],
    },
    {
      key: "cloud",
      title: "Cloud Computing",
      tech: "AWS, Azure, GCP, Docker, Kubernetes, Virtualization",
      desc: "Design scalable cloud solutions for global businesses.",
      careers: [
        "Cloud Engineer",
        "Cloud Architect",
        "DevOps Engineer (₹6–21 LPA)",
      ],
    },
    {
      key: "datascience",
      title: "Data Science & Analytics",
      tech: "Python, SQL, Pandas, Tableau, ML Algorithms, Stats",
      desc: "Turn data into insights for finance, healthcare, & tech.",
      careers: [
        "Data Analyst",
        "Data Scientist",
        "Business Analyst (₹8–15 LPA)",
      ],
    },
    {
      key: "cybersecurity",
      title: "Cybersecurity",
      tech: "Ethical Hacking, Penetration Testing, Firewalls, Wireshark, Encryption",
      desc: "Protect systems from cyber threats.",
      careers: [
        "Cybersecurity Analyst",
        "Ethical Hacker",
        "Security Engineer (₹8–25 LPA)",
      ],
    },
    {
      key: "blockchain",
      title: "Blockchain Technology",
      tech: "Solidity, Ethereum, Cryptography, Distributed Systems",
      desc: "Build decentralized apps & smart contracts for Web3.",
      careers: ["Blockchain Developer", "Smart Contract Engineer (₹6–100 LPA)"],
    },
    {
      key: "testing",
      title: "Software Testing",
      tech: "Manual Testing, Automation Testing, Selenium, JIRA, TestNG",
      desc: "Ensure software quality with industry-standard tools.",
      careers: [
        "QA Engineer",
        "Test Automation Engineer",
        "Quality Analyst (₹4–12 LPA)",
      ],
    },
    {
      key: "marketing",
      title: "Digital Marketing",
      tech: "SEO, Social Media, Google Ads, Analytics, Content Marketing",
      desc: "Boost brands online with data-driven strategies.",
      careers: [
        "Digital Marketing Specialist",
        "SEO Analyst",
        "Social Media Manager (₹4–15 LPA)",
      ],
    },
    {
      key: "sales",
      title: "Business Development & Sales",
      tech: "Lead Generation, Client Pitching, CRM (HubSpot, Salesforce), Sales Strategies",
      desc: "Drive business growth & close deals like a pro.",
      careers: [
        "Business Development Executive",
        "Sales Executive",
        "Account Manager (₹4–12 LPA)",
      ],
    },
    {
      key: "hr",
      title: "Human Resources (HR)",
      tech: "Recruitment, HR Tech (ATS, Payroll Tools), Employee Engagement, Labor Laws",
      desc: "Master HR management & tech-driven recruitment.",
      careers: [
        "HR Specialist",
        "Recruitment Consultant",
        "HR Tech Analyst (₹4–12 LPA)",
      ],
    },
  ];

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [open, setOpen] = useState(false);
  const [formApply, setFormApply] = useState(false);
  const [NewFormMobileValue, setNewFormMobileValue] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOpen = (data) => {
    console.log(data, "data==");
    const matchedCourse = courseDetails.find((course) => {
      if (course.title === data.role) return true;
      return false;
    });

    if (matchedCourse) {
      setSelectedCourse(matchedCourse);
      setOpen(true);
    }
  };

  const handleClose = () => {
    if (selectedTitle) {
      formik.resetForm();
      setOpen(false);
      setFormApply(false);
      setSelectedCourse(null);
    } else {
      setOpen(false);
      setFormApply(false);
      setSelectedCourse(null);
    }
  };

  const handleFormApply = (title) => {
    setFormApply(true);
    setSelectedTitle(title);
  };

  const formik = useFormik({
    initialValues: {
      internerName: "",
      internerCollege: "",
      internerCity: "",
      internermobileValue: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const payload = {
          internerName: values.internerName,
          internerCollege: values.internerCollege,
          internerLookingFor: selectedTitle ? selectedTitle : "",
          internerCity: values.internerCity,
          internermobileValue: values.internermobileValue,
        };

        console.log(payload, "payload====");

        const data = {
          apiUrl: httpService.internFormSubmit,
          payload: payload,
        };

        const messageSent = await internuserFormSubmit(data);
        // const messageSent = await internuserFormSubmit();

        if (messageSent.success === true) {
          toast.success(messageSent.message || "Form submitted successfully!");
          setTimeout(() => {
            window.$("#intern_apply").modal("hide");
            window.location.href = "https://beleaftechnologies.com/sucesspage";
          }, 1500);
          formik.resetForm();
        } else {
          toast.error(messageSent.message);
        }
      } catch (error) {
        console.error("Form submission error:", error);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <>
      <button onClick={() => handleOpen(data)} className="open-role-card">
        <span className="card-department">{data.department}</span>
        <h3 className="card-role">{data.role}</h3>
        <h6 className="card-duration">
          {data.durationTitle} : {data.duration}
        </h6>
        {/* <p className="card-type">{data.type}</p> */}
        <button className="mt-4 career-btn re-hero-btn nw_cr_btn_fz">
          <div className="nw_cr_ap_txt">Apply Now </div>
          <span className="mx-2 right-arr">
            <i className="fa-solid fa-arrow-right"></i>
          </span>
        </button>
        {/* <div className="card-time">
          <span>
            <i className="bi bi-briefcase"></i>
            {data.time}
          </span>
          <span>
            <i className="fa-solid fa-clock-rotate-left"></i>
            {data.months}
          </span>
        </div> */}
      </button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={style}
          className={`modals career_modals ${
            formApply && "career_form_modals"
          }`}
        >
          {!formApply ? (
            <div>
              <div className="career_modals-header">
                <div className="career_modal-arrow">
                  <i onClick={handleClose} className="fa-solid fa-xmark"></i>
                </div>
                <div className="modals-header_wrap">
                  <div>
                    <h5 className="career_modals-header-title">
                      {selectedCourse?.title || "Role Title"}
                    </h5>
                    <p className="career_modals-header-content">
                      Madurai, Tamil Nadu.
                    </p>
                  </div>
                  {/* <div className="ml-auto sm-btn-none">
                    <button
                      onClick={() => handleFormApply(selectedCourse?.title)}
                      className="career_modals-header-btn"
                    >
                      Apply Now
                    </button>
                  </div> */}
                </div>
              </div>

              <div className="career_modals-main">
                <div>
                  <h6 className="career_modals-main-title">Join Our Team!</h6>
                  <p className="career_modals-main-content">
                    {
                      "Beleaf Technologies, India's leading enterprise blockchain technology solution and service provider, is looking for passionate and driven individuals to join our growing team."
                    }
                    {/* selectedCourse?.desc || */}
                  </p>
                </div>

                {selectedCourse?.programs &&
                  selectedCourse.programs.length > 0 && (
                    <div className="mt-4">
                      <h6 className="career_modals-main-title">Programs:</h6>
                      {selectedCourse.programs.map((program, idx) => (
                        <div key={idx} className="mb-3">
                          <p className="career_modals-main-content pad_detailschange">
                            <strong style={{ color: "#0e0e10" }}>
                              {program.name}
                            </strong>
                          </p>
                          <ul className="career-lists">
                            <li className="career_modals-main-content">
                              {program.desc}
                            </li>
                          </ul>
                          <p className="career_modals-main-content">
                            <strong>Technologies:</strong> {program.tech}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}

                {selectedCourse?.tech && !selectedCourse?.programs && (
                  <div className="mt-4">
                    <h6 className="career_modals-main-title">Technologies:</h6>
                    <p className="career_modals-main-content">
                      {selectedCourse.tech}
                    </p>
                  </div>
                )}

                {selectedCourse?.careers &&
                  selectedCourse.careers.length > 0 && (
                    <div className="mt-4">
                      <h6 className="career_modals-main-title">
                        Career Opportunities:
                      </h6>
                      <ul className="career-lists">
                        {selectedCourse.careers.map((career, idx) => (
                          <li key={idx} className="career_modals-main-content">
                            {career}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                <div className="mt-4">
                  <h6 className="career_modals-main-title">Why Join Us?</h6>
                  <ul className="career-lists">
                    <li className="career_modals-main-content">
                      Be part of a fast-growing blockchain development company
                    </li>
                    <li className="career_modals-main-content">
                      Work in a dynamic and collaborative environment
                    </li>
                    <li className="career_modals-main-content">
                      Contribute to cutting-edge projects in the blockchain
                      space
                    </li>
                  </ul>
                </div>

                <div className="mt-4">
                  <h6 className="career_modals-main-title">About Us:</h6>
                  <p className="career_modals-main-content">
                    At Beleaf Technologies, we specialize in delivering
                    personalized blockchain solutions, blockchain development,
                    crypto exchange platforms, and token development services.
                    Our innovative approach helps businesses harness the power
                    of blockchain technology to drive growth and efficiency.
                  </p>
                </div>

                <div className="mt-4">
                  <div>
                    <span className="career_modals-details">Location : </span>
                    <span className="career_modals-details">
                      Madurai, Tamil Nadu (On-site only)
                    </span>
                  </div>
                  <div className="mt-3">
                    <span className="career_modals-details">Duration : </span>
                    <span className="career_modals-details">
                      {data && data.duration ? data.duration : ""}
                    </span>
                  </div>
                </div>

                <div className="ml-auto mt-3 sm-btn-none">
                  <button
                    onClick={() => handleFormApply(selectedCourse?.title)}
                    className="career_modals-header-btn"
                  >
                    Apply Now
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="career_modals-header">
                <div className="career_modal-arrow">
                  <i
                    onClick={() => handleClose()}
                    className="fa-solid fa-xmark"
                  ></i>
                </div>
                <div className="text-center">
                  <p className="career-form-content">Apply for</p>
                  <h4 className="career-form-title">
                    {selectedTitle ? selectedTitle : "-"}
                  </h4>
                </div>
              </div>
              <div className="career_modals-main">
                <form onSubmit={formik.handleSubmit}>
                  <div className="form-group whole_fom_pad row">
                    <div className="col-sm-12 pt-3">
                      <label className="career-form-label">
                        Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        // className="form-control"
                        className="career-form-input"
                        placeholder="Your Name"
                        name="internerName"
                        minLength={3}
                        maxLength={50}
                        value={formik.values.internerName}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          // Prevent leading space
                          if (value === "" || value[0] !== " ") {
                            formik.setFieldValue(name, value);
                          }
                        }}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.internerName &&
                        formik.errors.internerName && (
                          <span className="text-danger">
                            {formik.errors.internerName}
                          </span>
                        )}
                    </div>

                    <div className="col-sm-12 pt-3">
                      <label className="career-form-label">
                        Mobile Number<span className="text-danger">*</span>
                      </label>
                      <PhoneInput
                        country={"in"}
                        className="career-form-phone"
                        value={formik.values.internermobileValue}
                        onChange={(value) =>
                          formik.setFieldValue("internermobileValue", value)
                        }
                        onBlur={() =>
                          formik.setFieldTouched("internermobileValue", true)
                        }
                      />
                      {formik.touched.internermobileValue &&
                        formik.errors.internermobileValue && (
                          <span className="text-danger">
                            {formik.errors.internermobileValue}
                          </span>
                        )}
                    </div>

                    <div className="col-sm-12 pt-3">
                      <label className="career-form-label">
                        College Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        // className="form-control"
                        className="career-form-input"
                        placeholder="Your College Name"
                        name="internerCollege"
                        minLength={3}
                        maxLength={50}
                        value={formik.values.internerCollege}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          // Prevent leading space
                          if (value === "" || value[0] !== " ") {
                            formik.setFieldValue(name, value);
                          }
                        }}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.internerCollege &&
                        formik.errors.internerCollege && (
                          <span className="text-danger">
                            {formik.errors.internerCollege}
                          </span>
                        )}
                    </div>

                    <div className="col-sm-12 pt-3">
                      <label className="career-form-label">
                        City<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        // className="form-control"
                        className="career-form-input"
                        placeholder="Your City"
                        name="internerCity"
                        minLength={2}
                        maxLength={50}
                        value={formik.values.internerCity}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          // Prevent leading space
                          if (value === "" || value[0] !== " ") {
                            formik.setFieldValue(name, value);
                          }
                        }}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.internerCity &&
                        formik.errors.internerCity && (
                          <span className="text-danger">
                            {formik.errors.internerCity}
                          </span>
                        )}
                    </div>

                    <div className="col-lg-12">
                      <div className="p-0 pb-0 justify-content-center d-flex mt-3">
                        <button className="mt-3 career-file-btn re-hero-btn">
                          {isSubmitting ? (
                            <>
                              <span className="spinner_changes">
                                <span> Loading...</span>
                              </span>
                            </>
                          ) : (
                            <div className="nw_cr_pop_txt">Submit </div>
                          )}
                          <span className="mx-2 right-arr">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default OpenRoleCards;
